import JsonLd from 'components/JsonLd';

const CollectionPageJsonLd = ({ group }) => {
  const canonicalUrl = group.seo?.canonical_url
    || `${window.location.origin}/ng/${group.slug}/`;

  const schema = {
    "@context": "https://schema.org",
    "@type": "CollectionPage",
    "name": group.seo?.h1 || group.title,
    "description": group.seo?.seo_description || '',
    "image": group.image ? [group.image] : [],
    "url": canonicalUrl,
    "mainEntity": {
      "@type": "ProductGroup",
      "name": group.title,
      "image": group.image ? [group.image] : [],
      "description": group.seo?.seo_description || ''
    }
  };

  return <JsonLd data={schema} />;
};

export default CollectionPageJsonLd;
